<template>
  <LayoutDashboard title="Lançamentos">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarLancamentoBancario"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-lancamento-financeiro')"
          >Cadastrar</v-btn
        >
        <v-btn
          color="default"
          v-if="!showFiltroAvancado"
          outlined
          class="ml-2"
          @click="showFiltroAvancado = true"
          >Filtro<v-icon right dark> search </v-icon>
        </v-btn>
        <v-btn
          color="default"
          v-if="showFiltroAvancado"
          outlined
          class="ml-2"
          @click="showFiltroAvancado = false"
          >Filtro<v-icon right dark> close </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <h3>Registros: {{ getLancamentosBancarios.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getLancamentosBancarios.current_page"
          :length="getLancamentosBancarios.last_page"
          @input="listarLancamentoBancario({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-card-text v-if="showFiltroAvancado">
        <form>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-select
                class="mr-2 ml-2"
                :items="tiposPesquisas"
                v-model="tipoPesquisa"
                label="Pesquisar por:"
                outlined
                dense
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                class="mr-2 ml-2"
                outlined
                dense
                place
                type="date"
                label="Período Inicial"
                v-model="dataPagina.periodo_inicial"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                class="mr-2 ml-2"
                outlined
                dense
                place
                type="date"
                label="Período Final"
                v-model="dataPagina.periodo_final"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md12 class="mr-2 ml-2">
              <v-btn
                color="success"
                outlined
                block
                @click=" pesquisar()"
                >Filtrar</v-btn
              >
            </v-flex>
            <v-flex xs12 md12 class="mr-2 ml-2 mt-2">
              <v-btn
                color="primary"
                outlined
                block
                type="submit"
                @click="content = 'pdf'"
                >Imprimir</v-btn
              >
            </v-flex>
          </v-layout>
        </form>
      </v-card-text>

      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    label="Cód."
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th>Valor</th>
                <th>
                  <v-text-field
                    label="Fornecedor/Cliente"
                    v-model="dataPagina.contato"
                    @input="debouncedPesquisar()"
                    class="mt-2"
                    outlined
                    dense
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-text-field
                    label="Data"
                    v-model="dataPagina.dataLancamento"
                    @input="debouncedPesquisar()"
                    class="mt-2"
                    outlined
                    type="date"
                    dense
                  ></v-text-field>
                </th>
                <th width="20%">
                  <v-select
                    :items="['', ...getBancos]"
                    item-value="id"
                    item-text="nome"
                    v-model="dataPagina.bancoId"
                    label="Conta"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    outlined
                    dense
                  ></v-select>
                </th>
                <th width="10%">
                  <v-select
                    :items="['', 'CRÉDITO', 'DÉBITO']"
                    v-model="dataPagina.tipo"
                    label="Tipo"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    outlined
                    dense
                  ></v-select>
                </th>
                <th width="10%">
                <v-autocomplete
                    outlined
                    label="Exibir"
                    dense
                    :items="[10, 20, 30, 40, 50]"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="debouncedPesquisar({ ...dataPagina })"
                    class="mt-2"
                  ></v-autocomplete>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="l in getLancamentosBancarios.data" :key="l.id">
                <td align="center">{{ l.id }}</td>
                <td>{{ $helper.formatReal(parseFloat(l.valor)) }}</td>
                <td>{{ l.contato.nome }}</td>
                <td>{{ $helper.formatDate(l.data_lancamento) }}</td>
                <td>{{ l.banco.nome }}</td>
                <td>{{ l.tipo }}</td>
                <td align="center">
                  <TooltipButton
                    @click.native="visualizarLancamentoBancario(l)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="
                      $helper.verificaPermissao(
                        'visualizar-lancamento-financeiro'
                      )
                    "
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <ModalCadastro />
  </LayoutDashboard>
</template>

<script>
import ModalCadastro from "@/pages/financeiro/lancamentoBancario/ModalCadastro";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import LancamentoBancarioService from "@/services/LancamentoBancarioService";
var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
  },
  data() {
    return {
      funcionarios: [],
      showFiltroAvancado: false,
      tiposPesquisas: ["Data de Lançamento"],
      tipoPesquisa: "Data de Lançamento",
      periodo_inicial: moment().format("YYYY-MM-DD"),
      periodo_final: moment().format("YYYY-MM-DD"),
      content: "",
      dataPagina: {
        id: "",
        contato: "",
        dataLancamento: "",
        tipo: "",
        bancoId: "",
        page: 1,
        limit: 20,
        periodo_inicial: "",
        periodo_final: "",
      },

      // showPDF: false
    };
  },
  computed: {
    ...mapGetters([
      "getLancamentosBancarios",
      "getModalCadastroLancamentoBancario",
      "getBancos",
    ]),
  },
  methods: {
    ...mapActions([
      "listarLancamentoBancario",
      "visualizarLancamentoBancario",
      "cadastrarLancamentoBancario",
      "setModalListarLancamentoBancario",
      "listarBancos",
    ]),
    filtrar() {
      this.$store.commit("setOverlay", true);
      LancamentoBancarioService.listarPorDataDeLancamento({
        tipoPesquisa: this.tipoPesquisa,
        periodo_inicial: this.dataPagina.periodo_inicial,
        periodo_final: this.dataPagina.periodo_final,
        content: this.content,
      })
        .then((res) => {
          this.$store.commit("setOverlay", false);

          if (res.data.pdf_link) {
            this.$store.commit("setModalPrint", res.data.pdf_link);
            return;
          }

          this.$store.commit("setLancamentosBancarios", res.data);
        })
        .catch((e) => {
          this.$store.commit("setOverlay", false);
          this.$store.commit("snackbarError", "Erro ao filtrar lançamentos.");
        });
    },
    pesquisar() {
      this.listarLancamentoBancario(this.dataPagina);
    },
  },
  created() {
    this.listarLancamentoBancario(this.dataPagina);
    this.listarBancos();
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>